import React, { useEffect } from 'react'
import * as S from './About.styles'
import { useIntl } from 'gatsby-plugin-intl'
import useWindowDimensions from 'hooks/useWindowDimensions'
import Aos from 'aos'
import 'aos/dist/aos.css'

const About = () => {
  const { formatMessage, locale } = useIntl()
  const { width } = useWindowDimensions()

  useEffect(() => {
    Aos.init({ duration: 1000 })
  }, [])

  return (
    <S.About>
      <S.Wrapper id="about">
        <S.TitleWrapper locale={locale}>
          <S.AboutTitle>{formatMessage({ id: 'about.title' })}</S.AboutTitle>
        </S.TitleWrapper>

        <S.Content data-aos="fade-in">
          <S.Paragraph>
            <S.TextWrapper>
              <S.Text>{formatMessage({ id: 'about.paragraph-1' })}</S.Text>
              <S.Text>
                <S.Space>
                  {width > 768
                    ? formatMessage({ id: 'about.position-desktop' })
                    : formatMessage({ id: 'about.position-mobile' })}
                  {formatMessage({ id: 'about.paragraph-2' })}
                </S.Space>
              </S.Text>
              <S.Text>
                <strong>{formatMessage({ id: 'about.paragraph-3' })}</strong>
              </S.Text>
            </S.TextWrapper>
          </S.Paragraph>
          <S.ImageWrapper>
            <S.Video>
              <S.Iframe
                src={formatMessage({ id: 'about.video-link' })}
                width="650px"
                frameborder="0"
                title="Encontro Vale VPS"
                webkitallowfullscreen
                mozallowfullscreen
                allowfullscreen
              ></S.Iframe>
            </S.Video>
          </S.ImageWrapper>
        </S.Content>
      </S.Wrapper>
    </S.About>
  )
}

export default About
